import { useEffect, useRef, useState } from 'react';

import { NoVideo } from '../no-video/no-video';
import { Box, Spinner, TwoVideosPlace } from './video-cap.cp.styled';

// grace period (ms): how long we show the "connecting" spinner before we
// give up and fall back to the polished "no video signal" placeholder, so the
// panel can never spin forever.
const CONNECT_GRACE_MS = 5000;

/**
 * VideoCap — placeholder shown in a camera panel when there are no streams.
 *
 * Previously a bare grey box. Now it renders the CleverParking "no video
 * signal" empty state (NoVideo) centered on the dark panel. While a caller
 * marks it as still "connecting" (the legacy `loading1` class) we show a brief
 * spinner, but after CONNECT_GRACE_MS we fall back to the placeholder — the
 * panel can never spin endlessly.
 */
export const VideoCap = (props) => {
  const { className = '', style, ...rest } = props;
  const connecting = className.includes('loading1');
  const [graceOver, setGraceOver] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (connecting && !graceOver) {
      timerRef.current = setTimeout(() => setGraceOver(true), CONNECT_GRACE_MS);
      return () => clearTimeout(timerRef.current);
    }
  }, [connecting, graceOver]);

  const showSpinner = connecting && !graceOver;

  return (
    <Box className={'video-cap ' + className} style={style} {...rest}>
      {showSpinner ? <Spinner /> : <NoVideo />}
    </Box>
  );
};

export { TwoVideosPlace };
